import * as yup from 'yup';

export const SolarInspectionSchema = yup.object({
  id: yup.number().nullable(),
  uuid: yup.string().nullable(),
  solar_farm_id: yup.number().nullable(),
  solar_farm_uuid: yup.string().nullable(),
  org_id: yup.number().nullable(),
  name: yup.string().nullable(),
  status: yup.number().nullable(),
  created_tsecs: yup.number().nullable(),
  updated_tsecs: yup.number().nullable(),
  verified: yup.boolean().nullable(),
  inspection_tsecs: yup.number().nullable(),
  timezone: yup.string().nullable(),
  power_inspected: yup.number().nullable(),
  order_uuid: yup.string().nullable(),
  workflow_status: yup.number().nullable(),
  quality_checked: yup.number().nullable(),
});

export type SolarInspection = yup.InferType<typeof SolarInspectionSchema>;

export const SolarFarmSchema = yup.object({
  id: yup.number().defined(),
  uuid: yup.string().defined(),
  latitude: yup.number(),
  longitude: yup.number(),
  org_id: yup.number(),
  creator_id: yup.number(),
  client_org_id: yup.number(),
  name: yup.string().defined(),
  status: yup.number(),
  created_tsecs: yup.number(),
  updated_tsecs: yup.number().nullable(),
  solar_module_id: yup.number().nullable(),
  address: yup.string().nullable(),
  module_layout: yup.string().nullable(),
  module_mount: yup.string().nullable(),
  site_layout: yup.string().nullable(),
  commissioning_tsecs: yup.number().nullable(),
  version: yup.number(),
  source_farm_uuid: yup.string().nullable(),
  size: yup.number().nullable(),
  access_code: yup.string().nullable(),
  ppa_rate: yup.number().nullable(),
  row_child_process_status: yup.string().nullable(),
  site_status: yup.string().nullable(),
  peak_sunlight_hours_annual: yup.number().nullable(),
  ac_size_megawatts: yup.number().nullable(),
  country: yup.string().nullable(),
  state: yup.string().nullable(),
  asset_id: yup.string().nullable(),
  inspections: yup.array(SolarInspectionSchema.defined()).nullable(),
});

export type SolarFarm = yup.InferType<typeof SolarFarmSchema>;
